import styled, { createGlobalStyle } from 'styled-components';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//theme
import { homeColor } from '@/theme/ai';

// Scoped reset for the "Autonomy" visual language — this page's headings and
// body copy intentionally diverge from the site-wide type scale.
export const ProactiveLoadAuditsGlobalStyle = createGlobalStyle`
  html, body {
    background: ${homeColor.bg};
  }
`;

export const PageWrapper = styled.main`
  font-family: ${getToken('font-family-default')};
  font-weight: 500;
  color: ${homeColor.white};
  background: ${homeColor.bg};
  line-height: 1.55;
  -webkit-font-smoothing: antialiased;
  overflow-x: clip;
  position: relative;
`;
